import { useState } from "react";
import { MdLogout, MdDarkMode, MdLightMode } from "react-icons/md";
import { RiVideoUploadFill, RiVideoUploadLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { useAuth, useModal, useTheme, useVideo } from "../context";

export const Header = () => {
  const { encodedToken, handleLogout } = useAuth();
  const { setIsUploadVideoModal } = useModal();
  const { videos } = useVideo();
  const location = useLocation();
  const [searchVideo, setSearchVideo] = useState("");
  const { theme, setTheme } = useTheme();
  let searchedVideos = [...videos].filter((video) =>
    video.title.toLowerCase().includes(searchVideo.toLowerCase())
  );
  return (
    <header
      className={`website-header ${
        theme === "light" ? "dark-theme" : "light-theme"
      }`}
    >
      <div className="header-title-container">
        <Link to="/" className="header-title">
          <h1
            className={`font-weight-bold header-title ${
              theme === "light" ? "dark-theme" : "light-theme"
            }`}
          >
            <span className="app-title">
              Video<span className="header-title-logo">Dump</span>
            </span>
            <span className="mobile-app-title">
              V<span className="header-title-logo">D</span>
            </span>
          </h1>
        </Link>
      </div>
      <div className="search-wrapper">
        {location.pathname !== "/login" && location.pathname !== "/signup" && (
          <input
            className="search-input padding-xs"
            placeholder="Search your video"
            onChange={(e) => setSearchVideo(e.target.value)}
            value={searchVideo}
          />
        )}
        <div
          className={`searched-videos ${
            theme === "light" ? "dark-theme" : "light-theme"
          }`}
          style={{ display: searchVideo === "" ? "none" : "block" }}
        >
          {searchedVideos.length === 0 ? (
            <p
              className={`${
                theme === "light" ? "dark-theme" : "light-theme"
              } text-center padding-sm head-md`}
            >
              Video not found
            </p>
          ) : (
            <>
              {searchedVideos.map((video) => (
                <Link
                  className={`searched-video d-block ${
                    theme === "light" ? "dark-theme" : "light-theme"
                  }`}
                  to={`/video/${video._id}`}
                  state={video}
                  key={video._id}
                >
                  {video.title}
                </Link>
              ))}
            </>
          )}
        </div>
      </div>
      {encodedToken ? (
        <div className="d-flex">
          {theme === "light" ? (
            <MdLightMode
              className="mode-icon"
              onClick={() => setTheme("dark")}
            />
          ) : (
            <MdDarkMode
              className="mode-icon"
              onClick={() => setTheme("light")}
            />
          )}
          <div className="d-flex">
            <button
              className="upload-button"
              onClick={() => setIsUploadVideoModal((prev) => !prev)}
            >
              {theme === "light" ? (
                <RiVideoUploadFill className="mode-icon" />
              ) : (
                <RiVideoUploadLine className="mode-icon" />
              )}
            </button>
            <MdLogout className="logout-icon" onClick={handleLogout} />
          </div>
        </div>
      ) : (
        <div className="d-flex">
          {theme === "light" ? (
            <MdLightMode
              className="mode-icon"
              onClick={() => setTheme("dark")}
            />
          ) : (
            <MdDarkMode
              className="mode-icon"
              onClick={() => setTheme("light")}
            />
          )}
        </div>
      )}
    </header>
  );
};
